export const services = [
  {
    id: 'estrategia-digital',
    title: 'Estrategia Digital',
    shortDesc: 'Plan de acción personalizado para tu crecimiento digital',
    fullDesc: 'Toda empresa debe tener como punto de partida una estrategia para saber hacia dónde se dirige. Analizamos la situación actual de tu empresa, definimos objetivos realistas y medibles, y realizamos un plan de trabajo personalizado que se puede ejecutar en el corto plazo.',
    features: ['Análisis de la competencia', 'Análisis de situación actual', 'Objetivos de negocio', 'Estrategia de marketing digital', 'Procesos y acciones'],
    icon: 'ri-compass-3-line',
  },
  {
    id: 'identidad-visual',
    title: 'Identidad Visual de Marca',
    shortDesc: 'Creamos marcas distintivas, adaptables y memorables',
    fullDesc: 'Una marca debe ser distintiva, adaptable y memorable. Desarrollamos un sistema de reconocimiento visual que ayude a su fácil posicionamiento en el mercado.',
    features: ['Logo', 'Construcción de Logo', 'Paleta de colores', 'Tipografía de marca', 'Recursos gráficos', 'Iconografía de marca'],
    icon: 'ri-palette-line',
  },
  {
    id: 'reconocimiento-marca',
    title: 'Reconocimiento de Marca',
    shortDesc: 'Proyecta los atributos que te hacen distinto',
    fullDesc: 'Una marca debe saber cómo comportarse y proyectarse en el mercado para que las personas puedan entender y reconocer cuáles son los atributos que la hacen distinta a la competencia.',
    features: ['Papelería corporativa', 'Diseño de material impreso', 'Diseño de material digital', 'Diseño de etiquetas', 'Diseño de empaques', 'Presencia de marca', 'Merchandise', 'Brochure'],
    icon: 'ri-award-line',
  },
  {
    id: 'diseno-web',
    title: 'Diseño Web & E-commerce',
    shortDesc: 'Tu ventana digital de exposición y conversión',
    fullDesc: 'Desarrollamos sitios web que ayudan a tu empresa a brindar información relevante para el cliente, siendo una ventana de exposición para los productos o servicios que ofrece. Contribuye a un correcto posicionamiento de la marca.',
    features: ['Diseño web', 'Estructura del contenido', 'Programación web', 'Implementación de contenido', 'E-commerce'],
    icon: 'ri-global-line',
  },
  {
    id: 'redes-sociales',
    title: 'Gestión de Contenidos & Redes Sociales',
    shortDesc: 'Presencia digital rápida y efectiva',
    fullDesc: 'Es de suma importancia que las marcas tengan presencia en medios digitales, de esta manera ayudamos a que se posicionen de forma rápida y efectiva en el mercado.',
    features: ['Análisis y estrategia de contenido', 'Gestión y programación de contenido', 'Diseño de publicaciones', 'Redacción de contenido y blog', 'Responder comentarios'],
    icon: 'ri-share-line',
  },
  {
    id: 'email-marketing',
    title: 'E-mail Marketing',
    shortDesc: 'Fideliza e inspira la compra de forma personalizada',
    fullDesc: 'Una campaña de email marketing permite fidelizar al cliente y atraer su atención hacia productos o servicios de una manera más personalizada. Logrando así captar su atención e inspirar la compra.',
    features: ['Estrategia de contenido', 'Malla de contenido mensual', 'Envío masivo usando Mailchimp'],
    icon: 'ri-mail-line',
  },
  {
    id: 'publicidad-digital',
    title: 'Publicidad Digital',
    shortDesc: 'Campañas que potencian el alcance de tu marca',
    fullDesc: 'La elaboración de campañas digitales sirve para potenciar el alcance de tu marca. Realizamos campañas con concepto emocional y avisos directos asociados a productos de la marca.',
    features: ['Facebook, Instagram, Google Ads', 'Definición de objetivos', 'Gestión y programación', 'Diseño de contenido', 'Monitoreo de campaña', 'Medición de resultados'],
    icon: 'ri-megaphone-line',
  },
  {
    id: 'seo-analitica',
    title: 'Analítica Digital & SEO',
    shortDesc: 'Conoce a tu público y posiciona tu marca',
    fullDesc: 'La analítica digital permite conocer más a nuestro público y su comportamiento en los canales digitales. Implementamos estrategia SEO efectiva para lograr un posicionamiento en motores de búsqueda.',
    features: ['Definición de objetivos y KPIs', 'Implementación de herramientas', 'SEO enfocado en el nicho', 'Reportes y métricas'],
    icon: 'ri-bar-chart-2-line',
  },
];

export const stats = [
  { value: '+12', label: 'Años de experiencia' },
  { value: '+150', label: 'Proyectos completados' },
  { value: '+50', label: 'Clientes satisfechos' },
  { value: '+3', label: 'Países con presencia' },
];

export const clients = [
  { name: 'Travel Buddies Peru', type: 'Agencia de viaje' },
  { name: 'Ino Travel Peru', type: 'Agencia de viaje' },
  { name: 'Terrua Café', type: 'Café' },
  { name: 'PTC Titicaca', type: 'Agencia de viajes' },
  { name: 'Always Travel Peru', type: 'Agencia de viaje' },
  { name: 'Tex Luxury', type: 'Tour operador' },
  { name: 'Green House Tambopata', type: 'Ecolodge' },
  { name: 'San Martin Apart Hotel', type: 'Hotel' },
  { name: 'DKM Xplore', type: 'Tour operador' },
  { name: 'Peru Andes Top', type: 'Tour operador' },
];

export const testimonials = [
  {
    name: 'César Vásquez',
    role: 'CEO, Travel Buddies Peru',
    text: 'Trabajar con Hernan y su equipo ha sido clave para nuestro crecimiento. Su expertise en marketing digital para agencias de viaje es inigualable en el mercado peruano.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20man%20business%20portrait%20headshot%20warm%20lighting%20corporate%20style%20smiling%20confident%20latino%20businessman&width=100&height=100&seq=avatar-2&orientation=squarish',
  },
  {
    name: 'Lourdes Castillo',
    role: 'Directora, PTC Titicaca',
    text: 'Suvi Digital transformó completamente nuestra presencia digital. El rediseño de nuestro sitio web aumentó las consultas en un 200%. Entienden perfectamente el negocio turístico.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20woman%20business%20portrait%20headshot%20warm%20lighting%20corporate%20style%20smiling%20confident%20latina%20businesswoman&width=100&height=100&seq=avatar-1&orientation=squarish',
  },
  {
    name: 'Cecilia Molina',
    role: 'CEO, Ittacca Travel',
    text: 'La estrategia de inbound marketing que diseñaron para nosotros cambió la forma en que captamos clientes. Resultados medibles y un equipo realmente comprometido.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20woman%20business%20portrait%20headshot%20warm%20lighting%20corporate%20style%20smiling%20confident%20blonde%20businesswoman&width=100&height=100&seq=avatar-3&orientation=squarish',
  },
];

export const faqs = [
  {
    question: '¿Cuánto tiempo toma desarrollar un sitio web para una agencia de viajes?',
    answer: 'El tiempo de desarrollo varía según la complejidad del proyecto. Una landing page profesional puede estar lista en 2-3 semanas, mientras que un sitio web completo con múltiples destinos, tours y funcionalidades puede tomar entre 6-8 semanas. Siempre definimos un cronograma claro al inicio del proyecto.',
  },
  {
    question: '¿Trabajan solo con agencias de viajes y tour operadores?',
    answer: 'Nuestro nicho principal son agencias de viajes y tour operadores porque tenemos un entendimiento profundo de este sector. Sin embargo, también desarrollamos proyectos para otros rubros. Nuestro software Operturi está diseñado específicamente para agencias de viaje, pero las plataformas a medida las creamos para cualquier tipo de negocio.',
  },
  {
    question: '¿Qué es Operturi y cómo puede ayudar a mi agencia?',
    answer: 'Operturi es nuestro software especializado para agencias de viajes. Te permite gestionar cotizaciones, itinerarios, reservas, clientes y reportes en una sola plataforma. Reduce el tiempo administrativo hasta en un 60% y mejora la experiencia de tus clientes con propuestas profesionales y automatizadas.',
  },
  {
    question: '¿Cuál es el costo de una estrategia de marketing digital?',
    answer: 'El costo depende de los servicios que necesites y el alcance del proyecto. Ofrecemos desde consultorías estratégicas puntuales hasta planes mensuales completos que incluyen gestión de redes sociales, publicidad digital, email marketing y SEO. Te invitamos a una primera asesoría gratuita para evaluar tus necesidades y presentarte una propuesta a medida.',
  },
  {
    question: '¿Ofrecen garantía en sus servicios?',
    answer: 'Sí. Todos nuestros proyectos web incluyen 3 meses de soporte técnico post-lanzamiento sin costo adicional. Para campañas de publicidad digital, trabajamos con objetivos claros y KPIs medibles. Si no cumplimos los objetivos acordados, reestructuramos la estrategia sin costo adicional durante el primer mes.',
  },
  {
    question: '¿Cómo puedo agendar una asesoría gratuita?',
    answer: 'Es muy sencillo. Puedes completar el formulario de contacto en nuestra web, escribirnos por WhatsApp al +51 989 307 864, o enviarnos un email a hernan@suvidigital.com. Agenda tu primera asesoría gratuita de 30 minutos donde analizaremos tu situación actual y te daremos recomendaciones concretas.',
  },
];

export const methodologySteps = [
  {
    title: 'ATRAER',
    description: 'Captamos la atención de nuevos prospectos con contenido valioso y estrategias de alcance.',
    tools: ['Anuncios', 'Video', 'Blog', 'Redes Sociales', 'Estrategia de Contenido'],
    icon: 'ri-flashlight-line',
  },
  {
    title: 'INTERACTUAR',
    description: 'Conectamos con tu audiencia a gran escala nutriendo relaciones de valor.',
    tools: ['Flujos de venta', 'Email marketing', 'Bots conversacionales', 'Automatización'],
    icon: 'ri-customer-service-line',
  },
  {
    title: 'DELEITAR',
    description: 'Deleitamos a cada cliente de manera individual para fidelizar y generar referidos.',
    tools: ['Contenido inteligente', 'Email marketing', 'Informes de atribución', 'Automatización'],
    icon: 'ri-heart-line',
  },
];

export const operturiFeatures = [
  {
    title: 'Cotizaciones Automatizadas',
    description: 'Genera cotizaciones profesionales en minutos, no en horas.',
    icon: 'ri-file-list-3-line',
  },
  {
    title: 'Gestión de Itinerarios',
    description: 'Diseña y modifica itinerarios con arrastrar y soltar.',
    icon: 'ri-map-pin-line',
  },
  {
    title: 'Control de Reservas',
    description: 'Administra todas tus reservas desde un solo dashboard.',
    icon: 'ri-calendar-check-line',
  },
  {
    title: 'Base de Clientes',
    description: 'CRM integrado para conocer y fidelizar a tus viajeros.',
    icon: 'ri-group-line',
  },
  {
    title: 'Reportes y Métricas',
    description: 'Conoce tus números en tiempo real: ventas, comisiones, destinos top.',
    icon: 'ri-pie-chart-line',
  },
  {
    title: 'Propuestas Digitales',
    description: 'Envía propuestas interactivas que tus clientes pueden aprobar online.',
    icon: 'ri-send-plane-line',
  },
];

export const detailedServices = services.map((s) => ({
  id: s.id,
  title: s.title,
  icon: s.icon,
  description: s.fullDesc || s.shortDesc,
  features: s.features,
  pricing: s.id === 'diseno-web' ? 'Desde $1,500 USD' : s.id === 'publicidad-digital' ? 'Desde $800 USD/mes' : 'Consultar',
  duration: s.id === 'diseno-web' ? '4-8 semanas' : undefined,
}));

export const featuredServices = [
  {
    id: 'agentes-ia',
    title: 'Creación de Agentes IA',
    tag: 'Inteligencia Artificial',
    icon: 'ri-robot-2-line',
    description: 'Diseñamos agentes de inteligencia artificial a medida para agencias de viajes y tour operadores. Responden consultas, generan cotizaciones y califican leads en segundos, liberando a tu equipo de tareas repetitivas para que se enfoque en cerrar ventas y cuidar a tus clientes.',
    features: [
      'Asistentes conversacionales 24/7',
      'Automatización de cotizaciones',
      'Atención multicanal (Web, WhatsApp y redes)',
      'Respuestas entrenadas con tu contenido',
      'Calificación de leads en tiempo real',
      'Integración con tu CRM y sistemas',
    ],
    pricing: 'Desde $1,200 USD',
    duration: 'Implementación en 2-4 semanas',
  },
  {
    id: 'software-medida',
    title: 'Software a Medida',
    tag: 'Desarrollo & Tecnología',
    icon: 'ri-code-box-line',
    description: 'Desarrollamos plataformas y aplicaciones web a medida pensadas en el crecimiento de tu negocio. Mapeamos tus procesos, identificamos cuellos de botella y construimos herramientas que automatizan el trabajo manual para que operes de forma más rápida, efectiva y rentable.',
    features: [
      'Análisis y mapeo de procesos',
      'Diseño UX/UI centrado en el usuario',
      'Desarrollo web y apps a medida',
      'Automatización de flujos de trabajo',
      'Integraciones con sistemas externos',
      'Escalabilidad y soporte continuo',
    ],
    pricing: 'Cotización personalizada',
    duration: 'Entrega en 6-12 semanas',
  },
];

export const operturiScreenshots = [
  {
    title: 'Dashboard Principal',
    description: 'Vista general de ventas, reservas y tareas pendientes en un solo vistazo.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20dashboard%20interface%20software%20UI%20design%20with%20charts%20metrics%20sidebar%20navigation%20light%20theme%20minimal%20pastel%20colors&width=800&height=500&seq=operturi-1&orientation=landscape',
  },
  {
    title: 'Gestión de Cotizaciones',
    description: 'Crea, edita y envía cotizaciones profesionales con cálculo automático.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20software%20quotation%20management%20interface%20table%20list%20view%20clean%20UI%20light%20theme%20minimal%20pastel%20blue%20accent&width=800&height=500&seq=operturi-2&orientation=landscape',
  },
  {
    title: 'Base de Clientes',
    description: 'CRM con historial de viajes, preferencias y comunicaciones.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20CRM%20customer%20list%20interface%20clean%20UI%20design%20light%20theme%20contact%20cards%20minimal%20pastel%20colors%20software&width=800&height=500&seq=operturi-3&orientation=landscape',
  },
];

export const values = [
  {
    title: 'Especialización',
    description: 'Nos enfocamos exclusivamente en el sector turístico para ofrecer soluciones realmente efectivas.',
    icon: 'ri-focus-3-line',
  },
  {
    title: 'Innovación',
    description: 'Adoptamos tecnologías emergentes como IA y automatización para mantenerte a la vanguardia.',
    icon: 'ri-lightbulb-flash-line',
  },
  {
    title: 'Resultados',
    description: 'Nuestro éxito se mide por el crecimiento de tus métricas: leads, ventas y posicionamiento.',
    icon: 'ri-line-chart-line',
  },
  {
    title: 'Transparencia',
    description: 'Reportes claros, comunicación constante y sin sorpresas en cada proyecto.',
    icon: 'ri-shield-check-line',
  },
];

export const teamMembers = [
  {
    name: 'Hernán Suclla',
    role: 'Fundador & Estratega Digital',
    bio: 'Especialista en marketing digital con más de 7 años de experiencia en el sector turístico. Lidera la estrategia y visión de Suvi Digital.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20man%20portrait%20headshot%20warm%20natural%20lighting%20confident%20smile%20business%20attire%20modern%20office%20background&width=400&height=500&seq=team-1&orientation=portrait',
  },
  {
    name: 'María Elena Vásquez',
    role: 'Directora Creativa',
    bio: 'Diseñadora con pasión por las marcas turísticas. Crea identidades visuales que conectan con los viajeros a nivel emocional.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20headshot%20warm%20natural%20lighting%20confident%20smile%20creative%20professional%20modern%20studio&width=400&height=500&seq=team-2&orientation=portrait',
  },
  {
    name: 'Diego Carranza',
    role: 'Especialista en Publicidad Digital',
    bio: 'Certificado en Meta Ads y Google Ads. Optimiza campañas para maximizar el ROI de cada sol invertido en publicidad.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20young%20man%20portrait%20headshot%20warm%20lighting%20confident%20casual%20business%20attire%20modern%20background&width=400&height=500&seq=team-3&orientation=portrait',
  },
];

export const platforms = [
  {
    name: 'WordPress',
    description: 'CMS líder para sitios web corporativos y blogs de contenido turístico.',
    icon: 'ri-wordpress-line',
    category: ['CMS', 'Web'],
  },
  {
    name: 'Shopify',
    description: 'Plataforma e-commerce ideal para vender tours y experiencias online.',
    icon: 'ri-shopping-bag-2-line',
    category: ['E-commerce', 'Ventas'],
  },
  {
    name: 'HubSpot',
    description: 'CRM y marketing automation para gestionar leads y fidelizar clientes.',
    icon: 'ri-briefcase-4-line',
    category: ['CRM', 'Marketing'],
  },
  {
    name: 'Google Ads',
    description: 'Publicidad en búsqueda y display para captar viajeros con intención de compra.',
    icon: 'ri-google-line',
    category: ['Publicidad', 'Tráfico'],
  },
  {
    name: 'Meta Ads',
    description: 'Campañas en Facebook e Instagram para alcance y conversión.',
    icon: 'ri-facebook-circle-line',
    category: ['Publicidad', 'Redes Sociales'],
  },
  {
    name: 'Mailchimp',
    description: 'Email marketing automatizado para nutrir leads y fidelizar clientes.',
    icon: 'ri-mail-send-line',
    category: ['Email', 'Automatización'],
  },
  {
    name: 'Google Analytics',
    description: 'Análisis de tráfico web y comportamiento de usuarios para optimizar conversiones.',
    icon: 'ri-bar-chart-box-line',
    category: ['Analítica', 'SEO'],
  },
  {
    name: 'Notion',
    description: 'Gestión de proyectos, documentación y bases de conocimiento del equipo.',
    icon: 'ri-file-text-line',
    category: ['Productividad', 'Gestión'],
  },
  {
    name: 'Figma',
    description: 'Diseño de interfaces, prototipos y sistemas de diseño para web y apps.',
    icon: 'ri-pen-nib-line',
    category: ['Diseño', 'UI/UX'],
  },
];

export const operturiPainPoints = [
  {
    title: 'Cotizaciones manuales en Excel',
    description: 'Elaboración de cotizaciones y presupuestos manualmente en hojas de cálculo, sin control de versiones ni flujo de aprobación.',
    icon: 'ri-file-excel-line',
  },
  {
    title: 'Papeleo disperso en múltiples canales',
    description: 'Correos, WhatsApp y archivos desordenados en diferentes carpetas. Nada centralizado, nada rastreable.',
    icon: 'ri-folders-line',
  },
  {
    title: 'Operación sin visibilidad controlada',
    description: 'No sabes quién, cuándo o por qué se modificó una reserva. Falta trazabilidad y control de tu operación diaria.',
    icon: 'ri-eye-off-line',
  },
];

export const operturiModules = [
  {
    title: 'Motor de Reservas',
    description: 'Gestiona tu inventario y disponibilidad en tiempo real. Controla habitaciones, asientos, guías y servicios desde un solo lugar.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20travel%20reservation%20management%20dashboard%20interface%20with%20calendar%20availability%20grid%2C%20clean%20minimal%20UI%20design%2C%20light%20theme%2C%20soft%20pastel%20blue%20and%20white%20colors%2C%20professional%20software%20screenshot&width=800&height=500&seq=operturi-mod-1&orientation=landscape',
  },
  {
    title: 'Cotizador',
    description: 'Crea cotizaciones profesionales en minutos con el motor de reservas integrado. Automatiza cálculos, impuestos y margenes sin errores.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20travel%20quotation%20builder%20interface%20with%20pricing%20tables%2C%20service%20items%2C%20clean%20minimal%20UI%20design%2C%20light%20theme%2C%20soft%20pastel%20blue%20accent%2C%20professional%20software%20screenshot&width=800&height=500&seq=operturi-mod-2&orientation=landscape',
  },
  {
    title: 'Operaciones',
    description: 'Gestiona pagos, reservas y toda la logística operativa desde el centro de operaciones. Todo centralizado, todo visible.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20operations%20dashboard%20with%20payment%20tracking%2C%20reservation%20status%20cards%2C%20task%20list%2C%20clean%20minimal%20UI%20design%2C%20light%20theme%2C%20soft%20pastel%20colors%2C%20professional%20software%20screenshot&width=800&height=500&seq=operturi-mod-3&orientation=landscape',
  },
];

export const operturiSteps = [
  {
    num: '01',
    title: 'Configura tus proveedores',
    description: 'Agrega todos tus hoteles, tours, transportes y servicios con sus tarifas y disponibilidades.',
    icon: 'ri-building-line',
  },
  {
    num: '02',
    title: 'Cotiza en minutos',
    description: 'Crea propuestas profesionales con precios calculados automáticamente según tus reglas comerciales.',
    icon: 'ri-calculator-line',
  },
  {
    num: '03',
    title: 'Conecta de forma segura',
    description: 'Recibe pagos con pasarela de pago integrada y envía confirmaciones automáticas a tus clientes.',
    icon: 'ri-shield-check-line',
  },
  {
    num: '04',
    title: 'Coordina toda tu operación',
    description: 'Gestiona reservas, asignación de guías y comunicación con proveedores desde un solo tablero.',
    icon: 'ri-dashboard-line',
  },
];

export const operturiWhyChoose = [
  'Ahorra horas de trabajo operativo reduciendo tareas manuales en cotizaciones, reservas y coordinación interna.',
  'Mantén toda tu información organizada: clientes, tours, proveedores y reservas centralizadas en un solo sistema.',
  'Mejora el control de tu operación con alertas automáticas de vencimientos, pagos pendientes y cambios de estado.',
  'Toma decisiones con información real accediendo a reportes de ventas, rentabilidad y ocupación en tiempo real.',
  'Controla el rendimiento de tu agencia con métricas claras de ventas, conversiones y rentabilidad por destino.',
  'Integra tus herramientas actuales conectando con Stripe, HubSpot, WhatsApp y más plataformas que ya usas.',
];

export const operturiIntegrations = [
  { name: 'Pasarela de pago', icon: 'ri-bank-card-line' },
  { name: 'CRM', icon: 'ri-customer-service-line' },
  { name: 'WhatsApp', icon: 'ri-whatsapp-line' },
  { name: 'Google Calendar', icon: 'ri-calendar-line' },
];

export const operturiPricingPlans = [
  {
    id: 'wuyayuro',
    name: 'Wuyayuro',
    price: '1% + US$0.30',
    period: 'por transacción',
    description: 'Ideal para agencias que prefieren pagar solo cuando venden. Sin costos fijos mensuales.',
    features: [
      'Motor de Reservas completo',
      'Cotizador profesional',
      'Pasarela de pago integrada',
      'Panel de administración',
      'Soporte por email',
    ],
    featured: false,
    cta: 'Empezar gratis',
  },
  {
    id: 'starter',
    name: 'OPERTURI Starter',
    price: 'US$100',
    period: '/mes',
    description: 'Para agencias en crecimiento que necesitan profesionalizar su operación.',
    features: [
      'Motor de Reservas completo',
      'Cotizador profesional',
      'Módulo de Operaciones',
      'Pasarela de pago integrada',
      'Soporte prioritario',
      'Hasta 3 usuarios',
    ],
    featured: false,
    cta: 'Probar 14 días gratis',
  },
  {
    id: 'pro',
    name: 'OPERTURI Pro',
    price: 'US$150',
    period: '/mes',
    description: 'Para agencias y tour operadores con alto volumen y operaciones complejas.',
    features: [
      'Todo Starter +',
      'Módulo de Operaciones avanzado',
      'Reportes personalizados',
      'Multiusuario ilimitado',
      'API y webhooks',
      'Soporte premium 24/7',
      'Onboarding personalizado',
    ],
    featured: true,
    cta: 'Probar 14 días gratis',
  },
];

export const operturiFAQs = [
  {
    category: 'Precios y planes',
    question: '¿Cuál es la diferencia entre Wuyayuro y OPERTURI?',
    answer: 'Wuyayuro es nuestro Motor de Reservas como producto independiente, ideal para agencias que solo necesitan gestionar disponibilidad y reservas. OPERTURI es la suite completa que incluye Motor de Reservas + Cotizador + Operaciones para una gestión integral.',
  },
  {
    category: 'Precios y planes',
    question: '¿Puedo cambiar de plan en cualquier momento?',
    answer: 'Sí, puedes cambiar de plan o de modelo de pago en cualquier momento. Si subes de plan, se prorratea la diferencia. Si bajas, el cambio se aplica al siguiente ciclo de facturación.',
  },
  {
    category: 'Precios y planes',
    question: '¿Hay costos adicionales por número de usuarios?',
    answer: 'En el plan Wuyayuro no hay límite de usuarios ya que se cobra por transacción. En Starter incluye hasta 3 usuarios y en Pro el número de usuarios es ilimitado sin costos extras.',
  },
  {
    category: 'Integración y configuración',
    question: '¿Qué pasarelas de pago puedo usar con mi propia cuenta?',
    answer: 'Puedes conectar tu propia cuenta de Stripe para procesar pagos directamente en tu cuenta bancaria. También soportamos otras pasarelas regionales según tu país.',
  },
  {
    category: 'Integración y configuración',
    question: '¿Ofrecen descuentos por pago anual?',
    answer: 'Sí, ofrecemos un descuento del 15% cuando eliges facturación anual en los planes Starter y Pro. Además incluye onboarding prioritario sin costo adicional.',
  },
  {
    category: 'Funcionalidad',
    question: '¿Puedo importar mis datos desde Excel u otro sistema?',
    answer: 'Sí, ofrecemos asistencia para la migración de datos desde Excel, Google Sheets o sistemas anteriores. Nuestro equipo te ayuda durante el onboarding para que no pierdas información.',
  },
  {
    category: 'Soporte y ayuda',
    question: '¿Qué tipo de soporte incluye cada plan?',
    answer: 'Wuyayuro incluye soporte por email con respuesta en 48 horas. Starter incluye soporte prioritario por email y chat en horario laboral. Pro incluye soporte premium 24/7 por email, chat y videollamada.',
  },
];